var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 5.83203H9.16699",
    stroke: "#212529",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 14.168H4.16699",
    stroke: "#212529",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 16.668C15.5477 16.668 16.667 15.5487 16.667 14.168C16.667 12.7873 15.5477 11.668 14.167 11.668C12.7863 11.668 11.667 12.7873 11.667 14.168C11.667 15.5487 12.7863 16.668 14.167 16.668Z",
    stroke: "#212529",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 8.33203C7.21372 8.33203 8.33301 7.21274 8.33301 5.83203C8.33301 4.45132 7.21372 3.33203 5.83301 3.33203C4.4523 3.33203 3.33301 4.45132 3.33301 5.83203C3.33301 7.21274 4.4523 8.33203 5.83301 8.33203Z",
    stroke: "#212529",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/Configure.51b07625c80f732244a3fad8f41e4872.svg";
export { ForwardRef as ReactComponent };